// just local place to define project-wide constants that aren't auto-exported to user project
// ==========

export {VWAF_exports_final as e} from ".";
export const g = window as any;